"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _constants = require("./constants");

var _Icon = _interopRequireDefault(require("../Icon"));

var _constants2 = require("../Icon/constants");

var _utils = require("../../utils");

require("./Title.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Pages and blocks' headers. */
function Title(props) {
  var type = props.type,
      link = props.link,
      children = props.children,
      className = props.className;
  var Heading = "h".concat(type);
  var classNames = (0, _utils.getClassNames)('Title', className);

  var InnerTitle = function InnerTitle(_ref) {
    var link = _ref.link,
        text = _ref.text;
    var externalLink = /^https?:\/\//.test(link);

    if (externalLink) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer"
      }, text, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        type: _constants2.ICON_TYPE_ARROW
      }));
    }

    if (link) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: link
      }, text, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        type: _constants2.ICON_TYPE_ARROW
      }));
    }

    return text;
  };

  return /*#__PURE__*/_react.default.createElement(Heading, {
    className: classNames
  }, /*#__PURE__*/_react.default.createElement(InnerTitle, {
    link: link,
    text: children
  }));
}

Title.propTypes = {
  /** Additional class to h1-h4 */
  className: _propTypes.default.string,

  /** Can be set to '1', '2', '3', '4' */
  type: _propTypes.default.oneOf(_constants.TITLE_TYPES),

  /** Whether the title has link. It should be marked with icon */
  link: _propTypes.default.string,

  /** @ignored */
  children: _propTypes.default.node
};
Title.defaultProps = {
  className: null,
  type: 1,
  link: null,
  children: null
};
var _default = Title;
exports.default = _default;